<template>
	<div>
		<div class="header" v-if="isPc" @mouseenter="headOpacityInner = 1" @mouseleave="() => { if(headOpacity == 0){ headOpacityInner = 0 } }"></div>
		<div class="header" id="header" :class="flagtops || showMenu ? 'on' : ''" :style="{ position: showPcShenming ? 'absolute' : 'fixed', top: headOpacityInner ? 0 : (isPc ? '-1rem' : '-1.2rem') }">
			<div class="zz" v-if="showsearch || showMenu" @click="() => { showsearch = false; showMenu = false }"></div>
			<div class="m">
				<img src="https://obs-gociif.ciif-expo.com/ciif/static/images/new/logo.png" class="logo" @click="goHostHome" />
				<div class="icon">
					<!-- <div class="text">{{ currentName }}</div> -->
					<div class="icon-menu" @click="closeMenu1" :class="showMenu ? 'active' : ''" v-if="isPc">
						<img v-if="showMenu" src="https://obs-gociif.ciif-expo.com/ciif/static/images/new/menu-close.png" class="img" />
						<img v-else src="https://obs-gociif.ciif-expo.com/ciif/static/images/new/menu.png" class="img" />
					</div>
					<div class="icon-menu" @touchstart="closeMenu1" :class="showMenu ? 'active' : ''" v-else>
						<img v-if="showMenu" src="https://obs-gociif.ciif-expo.com/ciif/static/images/new/menu-close.png" class="img" />
						<img v-else src="https://obs-gociif.ciif-expo.com/ciif/static/images/new/menu.png" class="img" />
					</div>
					<div class="search" :class="showsearch ? 'on' : ''">
						<div @click="searchchange" v-if="isPc"></div>
						<div @touchstart="searchchange" v-else></div>
					</div>
					<div class="language" :class="lang ? '' : 'on'" @click="changeLang"></div>
					<!-- <div class="menu" @click="mobileflag = true"></div> -->
				</div>
			</div>

			<div class="menu-content" v-if="showMenu">
				<div class="menu-content-top" v-if="isPc">
					<div class="menu-content-top1" v-for="(v, i) in mobilelist" v-if="!v.hide && v.children && v.children.length" :key="i">
						<a href="javascript:void(0)" @click="openLink(v, i)">{{ v['name' + En] }}</a>
						
						<template v-for="(c, ci) in v.children">
							<el-tooltip v-if="(c.name === '观众登记' || c.name === '媒体登记') && visitorIsClose" popper-class="expect-tooltips" effect="dark" :content="En ? 'Coming Soon' : '暂未开放 敬请期待'" placement="top-start">
								<div class="menu-content-top2" :class="headIndex == i && currentName == c['name' + En] ? 'active' : ''">{{ c['name' + En] }}</div>
							</el-tooltip>
							<div v-else class="menu-content-top2" :class="headIndex == i && currentName == c['name' + En] ? 'active' : ''" @click="openChlidren(c, i, c.name)">{{ c['name' + En] }}</div>
						</template>
					</div>
				</div>
				<div class="menu-content-top" v-else>
					<el-collapse v-model="activeNames">
						<el-collapse-item class="menu-content-top1" :class="activeNames.includes(i) ? 'active' : ''" v-for="(v, i) in mobilelist" v-if="!v.hide && v.children && v.children.length" :key="i" :name="i">
							<template slot="title">
								<a href="javascript:void(0)">
									<span v-if="!v.link">{{ v['name' + En] }}</span>
									<span v-else @click="openLink(v, i)">{{ v['name' + En] }}</span>
									<img v-if="!isPc && activeNames.includes(i)" src="https://obs-gociif.ciif-expo.com/ciif/static/images/new/wap/menu-icon-active.png" alt="">
									<img v-if="!isPc && !activeNames.includes(i)" src="https://obs-gociif.ciif-expo.com/ciif/static/images/new/wap/menu-icon.png" alt="">
								</a>
							</template>
							<template v-for="(c, ci) in v.children">
								<el-tooltip v-if="(c.name === '观众登记' || c.name === '媒体登记') && visitorIsClose" popper-class="expect-tooltips" effect="dark" :content="En ? 'Coming Soon' : '暂未开放 敬请期待'" placement="top-start">
									<div class="menu-content-top2" :class="headIndex == i && currentName == c['name' + En] ? 'active' : ''">{{ c['name' + En] }}</div>
								</el-tooltip>
								<div v-else class="menu-content-top2" :class="headIndex == i && currentName == c['name' + En] ? 'active' : ''" @click="openChlidren(c, i, c.name)">{{ c['name' + En] }}</div>
							</template>
						</el-collapse-item>
					</el-collapse>
				</div>
				<div class="menu-content-bottom">
					<div v-for="(item, index) in list" :key="index">
						<img @click.stop="itemFn(item)" :src="item.underlayUrl + '?x-image-process=image/resize,w_1200,limit_0'" alt="">
						<p v-if="!En" v-html="visitorTitles[index]"></p>
					</div>
				</div>
			</div>

			<div class="search-mask-content" v-if="showsearch">
				<div class="line"></div>
				<div class="search-mask-content-inner">
					<div class="search-1">
						{{ $t('search0') }}
					</div>
					<div class="search-2">
						<input type="text" :placeholder="En ? 'Keyword…' : '输入…'" name="" id="" v-model="searchValue" @keyup.enter="toSearch"/>
						<img src="https://obs-gociif.ciif-expo.com/ciif/static/images/new/search-mask-icon.png" @click="toSearch" alt="">
					</div>
					<div class="search-3">
						<div class="search-3-item">{{ $t('search1') }}</div>
						<div class="search-3-item">{{ $t('search2') }}</div>
						<div class="search-3-item">{{ $t('search3') }}</div>
					</div>
				</div>
			</div>
		</div>
		<div class="nulls"></div>
	</div>
</template>

<script>
import protal from "@/api/protal";
import { mapState } from "vuex";
export default {
	name: 'heads',
	data() {
		return {
			headOpacityInner: 1,
			activeNames: [],
			timer: null,
			showMenu: false,
			mobileflag: false,
			lang: true,
			searchflag: false,
			show: false,
			showsearch: false,
			mobilelist: [],
			flagtops: false,
			activateIndex1: 0,
			activateIndex2: 0,
			searchValue: '',
			list: [],
			visitorTitles: ['数控机床与金属加工展', '工业自动化展','绿色低碳展','新一代信息技术与应用展','智慧能源展','交通运输装备展','机器人展','科技创新展','新材料产业展']
		}
	},
	props: {
		type: '',
		showPcShenming: false,
		headOpacity: {
			type: Number,
			default: 1
		}
	},
	created() {
		this.getWebHomeExhibit()
		protal.getHomeNavMenu('home_nav_code').then(r => {
			this.mobilelist = r.data
			this.$store.commit('setHeadList', r.data)
		})
	},
	watch: {
		headOpacity(v) {
			this.headOpacityInner = v
		},
		'$route.path': {
			handler(v) {
				if (!['/', '/home'].includes(v)) {
					this.flagtops = true
				} else {
					this.flagtops = false
				}
			},
			immediate: true
		}
	},
	computed: {
		...mapState({
			headIndex: state => state.headIndex,
			leftIndex: state => state.leftIndex,
		}),
		pageName() {
			return this.$store.state.pageName || {}
		},
		currentName() {
			if (this.mobilelist && this.mobilelist.length && this.mobilelist[Number(this.headIndex)]) {
				const obj = this.mobilelist[Number(this.headIndex)]

				if (obj.children && obj.children.length) {
					const smallObj = obj.children.find(x => x.name == this.leftIndex)
					
					if (smallObj) {
						return smallObj[this.En ? 'nameEn' : 'name']
					}
				} else {
					return obj[this.En ? 'nameEn' : 'name']
				}
			}
		}
	},
	mounted() {
		window.addEventListener('scroll', this.handleScroll)
	},
	methods: {
		closeMenu1() {
			this.showMenu = !this.showMenu
		},
		itemFn(v) {
			this.$router.push({path:'/zhanlan',query:{uuid:v.uuid}})
			// const headList = this.$store.state.headList
			// const headIndex = this.$store.state.headIndex
			// this.$jsAPI('track', 'ciif_gbzyExhibitionListClick', {
			// 	contentID_var: v.uuid,
			// 	contentName_var: v.name,
			// 	firstNavigationName_var: headList[headIndex].name,
			// 	secondNavigationName_var: headList[headIndex].children && headList[headIndex].children.length ? localStorage.getItem('leftIndex') : ''
			// })
		},
		showRight(i, ci) {
			this.activateIndex1 = i
			this.activateIndex2 = ci
			this.show = true
		},
		searchval() {
			this.searchflag = true
		},
		handleScroll() {
			let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
			if (scrollTop > 0) {
				this.flagtops = true
			} else {
				this.flagtops = false
			}
			if (!['/', '/home'].includes(this.$route.path)) {
				this.flagtops = true
			}
		},
		beforeDestroy() {
			window.removeEventListener('scroll', this.handleScroll)
		},
		// 点击二级菜单
		openChlidren(c, i, leftIndex) {
			this.$jsAPI('track', 'ciif_pageHead_all', { contentName_var: '二级导航' })
			this.$jsAPI('track', 'ciif_pageHead_secondNavigation', {
				firstNavigationID_var: '无',
				firstNavigationName_var: this.mobilelist[i].name,
				contentID_var: '无',
				contentName_var: c.name
			})
			
			let type = c.type
			
			if (type == 1 || type == 2) {
				this.$store.commit('setPageName', c)
				this.$store.commit('setLeftIndex', leftIndex)
				this.openLink({ link: '/match_process?code=' + c.code + '&pageType=homePage' }, i)
			} else if (type == 3) {
				window.open(c['outLink' + this.En] || c.outLink);
			} else if (type == 4) {
				window.open(c['fileUrl' + this.En] || c.outLink);
			} else {
				this.$store.commit('setLeftIndex', leftIndex)
				this.openLink(c, i)
			}
			this.mobileflag = false
		},
		// 点击一级菜单
		openLink(v, i) {
			this.showMenu = false
			this.$jsAPI('track', 'ciif_pageHead_all', { contentName_var: '一级导航' })
			this.$jsAPI('track', 'ciif_pageHead_firstNavigation', {
				contentID_var: '无',
				contentName_var: v.name
			})
			if (v.link) {
				this.$store.commit('setHeadIndex', i)
				if (v.query) {
					this.$router.push({ path: v.link, query: { ...v.query } })
				} else {
					this.$router.push({ path: v.link })
				}
				this.mobileflag = false
			} else {
				if (!this.isPc) {
					this.$store.commit('setHeadIndex', i)
				}
			}
		},
		toSearch() {
			if (this.searchValue) {
				this.$router.push({ name: 'search', query: { val: this.searchValue } })
			}
			
			this.searchflag = false
			this.showsearch = false
		},
		searchchange() {
			this.searchflag = !this.searchflag
			this.showsearch = !this.showsearch
			// if (!this.showsearch) {
			// 	this.toSearch()
			// }
		},
		changeLang() {
			let locale = this.$i18n.locale;
			locale === "ch" ? (this.$i18n.locale = "en") : (this.$i18n.locale = "ch");
			localStorage.setItem("lang", this.$i18n.locale);
			if (this.lang) {
				this.lang = false
			} else {
				this.lang = true
			}
		},
        // 官网查询专业展知名展商
        getWebHomeExhibit() {
            protal.getWebHomeExhibit().then(r => {
                this.list = r.data;
            });
        },
	}
}
</script>

<style lang="less" scoped>
@media screen and (min-width: 769px) {
	.search-mask-content {
		position: absolute;
		left: 0;
		right: 0;
		top: 0;
		background: #0B243F;

		.line {
			height: 100px;
			border-bottom: 2px solid #F4501C;
		}

		.search-mask-content-inner {
			width: 1640px;
			margin: 0 auto;
			padding: 28px 0 30px;
			
			.search-1 {
				font-family: syn;
				font-weight: 400;
				font-size: 20px;
				color: #F4501C;
				line-height: 27px;
				text-align: left;
				font-style: normal;
				margin-bottom: 20px;
			}

			.search-2 {
				height: 84px;
				margin-bottom: 40px;
				position: relative;

				input {
					width: 100%;
					background: none;
					border: none;
					outline: none !important;
					border-bottom: 1px solid rgba(255,255,255,0.3);
					font-family: Inter, syn;
					font-weight: 400;
					font-size: 36px;
					color: #FFFFFF !important;
					line-height: 44px;
					height: 84px;
					text-align: left;
					font-style: normal;
				}

				img {
					position: absolute;
					right: 0;
					top: 50%;
					transform: translateY(-50%);
					width: 40px;
					height: 40px;
					cursor: pointer;
				}
			}

			.search-3 {

				.search-3-item {
					font-family: MiSans, MiSans;
					font-weight: 400;
					font-size: 20px;
					color: #FFFFFF;
					line-height: 27px;
					text-align: left;
					font-style: normal;
					margin-bottom: 17px;
				}
			}
		}
	}

	.mobile_fadein {
		display: none;
	}

	.header .m > ul > li .showbox .fadein .item .text{
		font-family: '微软雅黑';
	}
	.header .m>ul>li .showbox .fadein .more {
		display: block;
		font-size: .12rem;
		color: #FC581C;
		padding-top: .2rem;
		border-top: 1px solid #808080;
		width: calc(100% - .48rem);
		margin: 0 auto;
		padding-bottom: .67rem;
		box-sizing: border-box;
		margin-top: .2rem;
		padding-left: 0;
	}

	.header {
		width: 100%;
		position: fixed;
		z-index: 10;
		left: 0;
		height: 1rem;
		transition: top 1s;
		top: 0;

		&:hover {
			top: 0 !important;
		}

		.menu-content {
			position: absolute;
			left: 0;
			right: 0;
			top: 100px;
			background-color: #0B243F;
			border-top: 2px solid #F4501C;

			.menu-content-top {
				padding: 42px 140px 50px 140px;
				display: flex;

				.menu-content-top1 {
					flex: 0 0 280px;
					margin-right: 60px;

					a {
						display: block;
						font-family: syb;
						font-weight: 500;
						font-size: 24px;
						color: #F4501C;
						line-height: 24px;
						text-align: left;
						font-style: normal;
						padding-bottom: 14px;
						border-bottom: 1px solid rgba(255,255,255,0.2);
						margin-bottom: 5px;
					}
				}

				.menu-content-top2 {
					font-family: syn;
					font-weight: 400;
					font-size: 18px;
					color: #FFFFFF;
					line-height: 30px;
					padding: 5px 0;
					text-align: left;
					font-style: normal;
					cursor: pointer;
					position: relative;

					&:hover, &.active {

						&::after {
							content: "";
							position: absolute;
							left: 0;
							right: 0;
							bottom: 0;
							border-bottom: 1px solid #F4501C;
						}

						&::before {
							content: "";
							width: 26px;
							height: 26px;
							background-image: url(https://obs-gociif.ciif-expo.com/ciif/static/images/new/menu-right.jpg);
							background-size: cover;
							position: absolute;
							right: 0;
							top: 50%;
							transform: translateY(-50%);
						}
					}
				}
			}

			.menu-content-bottom {
				width: 1920px;
				padding: 20px 0;
				background: rgba(255, 255, 255, 0.05);
				display: flex;
				justify-content: center;

				&>div {
					width: 140px;
					display: flex;
					flex-direction: column;
					align-items: center;
				}

				img {
					width: 72px;
					height: auto;
					margin: 0 20px;
					border-radius: 8px;
					cursor: pointer;
				}

				p {
					font-family: MiSans, MiSans;
					font-weight: 400;
					font-size: 14px;
					color: #FFFFFF;
					line-height: 16px;
					text-align: center;
					font-style: normal;
					margin-top: 8px;
					white-space: nowrap;
				}
			}
		}

		.zz {
			content: '';
			width: 100%;
			height: 200vh;
			background: rgba(5, 14, 27, 0.5);
			backdrop-filter: blur(4px);
			position: absolute;
			left: 0;
			top: 100px;
			z-index: 0;
		}

		&.on {
			background: #0B243F;
		}

		.m {
			width: 16rem;
			height: 100px;
			display: flex;
			margin: 0 auto;
			align-items: center;
			justify-content: space-between;
			position: relative;
			z-index: 1;

			.logo {
				display: block;
				width: 180px;
				height: auto;
				cursor: pointer;
			}

			.icon {
				display: flex;
				align-items: center;

				.text {
					font-family: Inter, syn;
					font-weight: 400;
					font-size: 20px;
					color: #FFFFFF;
					line-height: 24px;
					text-align: left;
					font-style: normal;
					margin-right: 40px;
					cursor: pointer;
				}

				.icon-menu {
					width: 100px;
					height: 56px;
					background: rgba(255,255,255,0.2);
					border-radius: 12px;
					display: flex;
					align-items: center;
					justify-content: center;
					cursor: pointer;

					.img {
						width: 24px;
						height: auto;
					}

					&:hover, &.active {
						background: #F4501C;
					}
				}

				.menu {
					width: .36rem;
					height: .36rem;
					background-image: url(../assets/images/menu.png);
					background-size: 100% 100%;
					margin-left: .36rem;
					display: none;
				}

				.search {
					position: relative;
					z-index: 999;
					cursor: pointer;
					margin: 0 8px;

					div {
						background-image: url(https://obs-gociif.ciif-expo.com/ciif/static/images/new/search.png);
						background-size: 24px 24px;
						background-repeat: no-repeat;
						background-position: center center;
						width: 56px;
						height: 56px;
						background-color: rgba(255,255,255,0.2) !important;
						border-radius: 12px;
						display: flex;
						align-items: center;
						justify-content: center;

						&:hover {
							background-color: #F4501C;
						}
					}

					&.on {
						div {
							background-image: url(https://obs-gociif.ciif-expo.com/ciif/static/images/new/search-close.png);
						}

						input {
							left: -2.6rem;
							display: block;
						}
					}

					input {
						border: none;
						background: none;
						width: 2.40rem;
						height: .36rem;
						background: #FFFFFF;
						border-radius: .18rem;
						padding-left: .2rem;
						transition: all .3s;
						position: absolute;
						left: -2.6rem;
						top: 50%;
						transform: translateY(-50%);
						display: none;
						font-size: .18rem;
						color: #666666;
					}
				}

				.language {
					position: relative;
					cursor: pointer;
					background-image: url(https://obs-gociif.ciif-expo.com/ciif/static/images/new/lang.png);
					background-size: 24px 24px;
					background-repeat: no-repeat;
					background-position: center center;
					width: 56px;
					height: 56px;
					background-color: rgba(255,255,255,0.2);
					border-radius: 12px;
					display: flex;
					align-items: center;
					justify-content: center;

					&:hover {
						background-color: #F4501C;
					}

					&.on {
						// background-image: url(../assets/images/ens4.png);

						// &:hover {
						// 	background-image: url(../assets/images/ens3.png);
						// }
					}

					img {
						display: block;
					}
				}
			}

			&>ul {
				display: flex;
				height: .84rem;
				position: relative;
				align-items: center;

				&>li {
					height: 100%;
					transition: all .1s;
					border-radius: 0 0 .16rem .16rem;
					margin: 0 .04rem;

					a {
						padding: 0 .28rem;
						white-space: nowrap;
						min-width: .92rem;
					}

					&:hover {
						.showbox {
							opacity: 1;
							top: calc(100% + .06rem);
							visibility: inherit;
						}
					}

					.lines {
						height: .06rem;
					}

					.showbox {
						width: 10.22rem;
						overflow: hidden;
						display: flex;
						border-radius: .2rem;
						background: #EAEAEB;
						position: absolute;
						visibility: hidden;
						box-shadow: 0px 4px 12px 0px rgba(34,34,34,0.2);
						transition: all .3s;
						opacity: 0;
						left: 0;
						top: 120%;

						.fadein {
							overflow: hidden;
							width: calc(100% - 6.87rem);
							background: #DFDFDF;

							.item {
								overflow: hidden;
								padding: .36rem .2rem 0 .2rem;

								img {
									width: 100%;
									height: auto;
								}

								/deep/ .text {
									font-size: .12rem;
									line-height: .2rem;
									font-weight: normal;
									color: #808080;
								}

								ul {
									overflow: hidden;

									li {
										display: flex;
										padding: .06rem 0;
										align-items: flex-start;
										width: 100%;

										p {
											font-size: .12rem;
											line-height: .2rem;
											color: #808080;
											font-family: "微软雅黑";
											white-space: nowrap;
										}

										div {
											overflow: hidden;
											font-size: .12rem;
											font-family: "微软雅黑";
											line-height: 1.666666666666667;
											color: #808080;
											width: calc(100% - .5rem);
										}
									}
								}
							}
						}

						.ws>ul {
							width: 6.87rem;
							display: flex;
							padding: .3rem .16rem;
							flex-wrap: wrap;

							li {
								// overflow: hidden;
								width: 33.33%;

								&:hover a {
									.grow {
										span {
											color: #FC581C;
											// transform: translateX(-20%);
										}

										p {
											color: #FC581C;
											border-bottom: 1px solid #FC581C;
										}
									}
								}

								a {
									display: flex;
									align-items: center;
									padding: .2rem .16rem;

									.icons {
										width: .44rem;
										height: .44rem;
										background: #fff;
										border-radius: 50%;
										display: flex;
										align-items: center;
										justify-content: center;

										img {
											display: block;
											max-width: 80%;
										}
									}

									.grow {
										flex: 1;
										overflow: hidden;
										margin-left: .14rem;

										p {
											width: 1.2rem;
											font-size: .2rem;
											color: #3C3C3C;
											border-bottom: 1px solid #999999;
											font-weight: bold;
											font-family: "微软雅黑";
											padding-bottom: .06rem;
											transition: all .1s;
										}

										span {
											display: block;
											font-size: .12rem;
											font-family: syn;
											line-height: .22rem;
											color: #999999;
											transition: all .1s;
											white-space: nowrap;
											width: 120%;
										}
									}
								}
							}
						}
					}

					&.on {
						background: #FC581C;
					}

					&:hover {
						background: #FC581C;
					}

					&>a {
						height: 100%;
						width: 100%;
						font-size: .18rem;
						color: #fff;
						display: flex;
						align-items: flex-end;
						box-sizing: border-box;
						justify-content: center;
						padding-bottom: .2rem;
					}
				}
			}
		}
	}

	.mobsearch {
		display: none;
	}
}

@media screen and (max-width: 768px) {
	.search-mask-content {
		position: absolute;
		left: 0;
		right: 0;
		top: 0;
		background: #0B243F;

		.line {
			height: 1.2rem;
			border-bottom: 2px solid #F4501C;
		}

		.search-mask-content-inner {
			width: 100%;
			margin: 0 auto;
			padding: 0.4rem 0.4rem 0.28rem;
			
			.search-1 {
				font-family: syn;
				font-weight: 400;
				font-size: 0.26rem;
				color: #F4501C;
				line-height: 0.31rem;
				text-align: left;
				font-style: normal;
				margin-bottom: 0.35rem;
			}

			.search-2 {
				height: 1rem;
				margin-bottom: 0.68rem;
				position: relative;

				input {
					width: 100%;
					background: none;
					border: none;
					outline: none !important;
					border-bottom: 1px solid rgba(255,255,255,0.3);
					font-family: Inter, syn;
					font-weight: 400;
					font-size: .4rem;
					color: #FFFFFF !important;
					line-height: .5rem;
					height: 1rem;
					text-align: left;
					font-style: normal;
				}

				img {
					position: absolute;
					right: 0;
					top: 50%;
					transform: translateY(-50%);
					width: 0.48rem;
					height: 0.48rem;
					cursor: pointer;
				}
			}

			.search-3 {

				.search-3-item {
					font-family: MiSans, MiSans;
					font-weight: 400;
					font-size: .26rem;
					color: #FFFFFF;
					line-height: .31rem;
					text-align: left;
					font-style: normal;
					margin-bottom: .32rem;
				}
			}
		}
	}

	.mobile_fadein {
		display: none;
	}

	.header .m > ul > li .showbox .fadein .item .text{
		font-family: '微软雅黑';
	}
	.header .m>ul>li .showbox .fadein .more {
		display: block;
		font-size: .12rem;
		color: #FC581C;
		padding-top: .2rem;
		border-top: 1px solid #808080;
		width: calc(100% - .48rem);
		margin: 0 auto;
		padding-bottom: .67rem;
		box-sizing: border-box;
		margin-top: .2rem;
		padding-left: 0;
	}

	.header {
		width: 100%;
		position: fixed;
		z-index: 10;
		left: 0;
		height: 1.2rem;
		transition: top 1s;
		top: 0;
		padding: 0 0.36rem;
		
		&:hover {
			top: 0 !important;
		}

		.menu-content {
			position: absolute;
			left: 0;
			right: 0;
			top: 1.2rem;
			max-height: calc(100vh - 1.2rem);
			border-top: 2px solid #F4501C;
			overflow: auto;

			.menu-content-top {
				padding: 0.18rem 0.36rem 2.2rem;
				background-color: #0B243F;

				.menu-content-top1 {

					a {
						width: 100%;
						display: block;
						font-family: syb;
						font-weight: 500;
						font-size: .32rem;
						color: #fff;
						line-height: .32rem;
						text-align: left;
						font-style: normal;
						position: relative;

						img {
							position: absolute;
							right: 0;
							top: 50%;
							transform: translateY(-50%);
							width: .28rem;
							height: .28rem;
							padding: .2rem;
							box-sizing: content-box;
						}
					}

					&.active {
						
						a {
							color: #F4501C;
						}
					}
				}

				.menu-content-top2 {
					font-family: syn;
					font-weight: 400;
					font-size: .28rem;
					color: rgba(255,255,255,0.8);
					line-height: .8rem;
					text-align: left;
					font-style: normal;
					cursor: pointer;
					position: relative;

					&.active {
						color: #F4501C;
					}
				}

				/deep/ .el-collapse {
					border: none;
					
					.el-collapse-item__header {
						background-color: transparent;
						border-color: rgba(255, 255, 255, 0.20);

						&.is-active {
							border-color: transparent;
						}

						.el-icon-arrow-right {
							display: none;
						}
					}

					.el-collapse-item__wrap {
						background-color: transparent;
						border-color: rgba(255, 255, 255, 0.20);
						
						.el-collapse-item__content {
							padding: 0 0 0.3rem;
						}
					}
				}
			}

			.menu-content-bottom {
				width: 100%;
				padding: 0.38rem 0 0.18rem 0.36rem;
				background: #172F49;
				display: flex;
				flex-wrap: wrap;

				&>div {
					margin-right: 0.2rem;
					margin-bottom: 0.2rem;
					width: 1.2rem;
				}

				img {
					width: 1.2rem;
					height: auto;
					border-radius: 0.2rem;
					cursor: pointer;
					margin: 0 auto;
				}

				p {
					font-family: MiSans, MiSans;
					font-weight: 300;
					font-size: .2rem;
					color: #FFFFFF;
					line-height: .28rem;
					text-align: center;
					font-style: normal;
				}
			}
		}

		.zz {
			content: '';
			width: 100%;
			height: 200vh;
			background: rgba(5, 14, 27, 0.5);
			backdrop-filter: blur(4px);
			position: absolute;
			left: 0;
			top: 100px;
			z-index: 0;
		}

		&.on {
			background: #0B243F;
		}

		.m {
			width: 100%;
			height: 100%;
			display: flex;
			margin: 0 auto;
			align-items: center;
			justify-content: space-between;
			position: relative;
			z-index: 1;

			.logo {
				display: block;
				width: 2.24rem;
				height: auto;
				cursor: pointer;
			}

			.icon {
				display: flex;
				align-items: center;

				.text {
					font-family: Inter, syn;
					font-weight: 400;
					font-size: 20px;
					color: #FFFFFF;
					line-height: 24px;
					text-align: left;
					font-style: normal;
					margin-right: 40px;
					cursor: pointer;
				}

				.icon-menu {
					width: 1.08rem;
					height: 0.68rem;
					background: rgba(255,255,255,0.2);
					border-radius: 0.16rem;
					display: flex;
					align-items: center;
					justify-content: center;
					cursor: pointer;

					.img {
						width: 0.36rem;
						height: auto;
					}

					&.active {
						background: #F4501C;
					}
				}

				.menu {
					width: .36rem;
					height: .36rem;
					background-image: url(../assets/images/menu.png);
					background-size: 100% 100%;
					margin-left: .36rem;
					display: none;
				}

				.search {
					position: relative;
					z-index: 999;
					cursor: pointer;
					margin: 0 8px;

					div {
						background-image: url(https://obs-gociif.ciif-expo.com/ciif/static/images/new/search.png);
						background-size: 0.36rem 0.36rem;
						background-repeat: no-repeat;
						background-position: center center;
						width: 0.68rem;
						height: 0.68rem;
						background-color: rgba(255,255,255,0.2) !important;
						border-radius: 0.16rem;
						display: flex;
						align-items: center;
						justify-content: center;

						&:hover {
							background-color: #F4501C;
						}
					}

					&.on {
						div {
							background-image: url(https://obs-gociif.ciif-expo.com/ciif/static/images/new/search-close.png);
						}

						input {
							left: -2.6rem;
							display: block;
						}
					}

					input {
						border: none;
						background: none;
						width: 2.40rem;
						height: .36rem;
						background: #FFFFFF;
						border-radius: .18rem;
						padding-left: .2rem;
						transition: all .3s;
						position: absolute;
						left: -2.6rem;
						top: 50%;
						transform: translateY(-50%);
						display: none;
						font-size: .18rem;
						color: #666666;
					}
				}

				.language {
					position: relative;
					cursor: pointer;
					background-image: url(https://obs-gociif.ciif-expo.com/ciif/static/images/new/lang.png);
					background-size: 0.36rem 0.36rem;
					background-repeat: no-repeat;
					background-position: center center;
					width: 0.68rem;
					height: 0.68rem;
					background-color: rgba(255,255,255,0.2);
					border-radius: 0.16rem;
					display: flex;
					align-items: center;
					justify-content: center;

					// &:hover {
					// 	background-color: #F4501C;
					// }

					&.on {
						background-color: #F4501C;
						// background-image: url(../assets/images/ens4.png);

						// &:hover {
						// 	background-image: url(../assets/images/ens3.png);
						// }
					}

					img {
						display: block;
					}
				}
			}

			&>ul {
				display: flex;
				height: .84rem;
				position: relative;
				align-items: center;

				&>li {
					height: 100%;
					transition: all .1s;
					border-radius: 0 0 .16rem .16rem;
					margin: 0 .04rem;

					a {
						padding: 0 .28rem;
						white-space: nowrap;
						min-width: .92rem;
					}

					&:hover {
						.showbox {
							opacity: 1;
							top: calc(100% + .06rem);
							visibility: inherit;
						}
					}

					.lines {
						height: .06rem;
					}

					.showbox {
						width: 10.22rem;
						overflow: hidden;
						display: flex;
						border-radius: .2rem;
						background: #EAEAEB;
						position: absolute;
						visibility: hidden;
						box-shadow: 0px 4px 12px 0px rgba(34,34,34,0.2);
						transition: all .3s;
						opacity: 0;
						left: 0;
						top: 120%;

						.fadein {
							overflow: hidden;
							width: calc(100% - 6.87rem);
							background: #DFDFDF;

							.item {
								overflow: hidden;
								padding: .36rem .2rem 0 .2rem;

								img {
									width: 100%;
									height: auto;
								}

								/deep/ .text {
									font-size: .12rem;
									line-height: .2rem;
									font-weight: normal;
									color: #808080;
								}

								ul {
									overflow: hidden;

									li {
										display: flex;
										padding: .06rem 0;
										align-items: flex-start;
										width: 100%;

										p {
											font-size: .12rem;
											line-height: .2rem;
											color: #808080;
											font-family: "微软雅黑";
											white-space: nowrap;
										}

										div {
											overflow: hidden;
											font-size: .12rem;
											font-family: "微软雅黑";
											line-height: 1.666666666666667;
											color: #808080;
											width: calc(100% - .5rem);
										}
									}
								}
							}
						}

						.ws>ul {
							width: 6.87rem;
							display: flex;
							padding: .3rem .16rem;
							flex-wrap: wrap;

							li {
								// overflow: hidden;
								width: 33.33%;

								&:hover a {
									.grow {
										span {
											color: #FC581C;
											// transform: translateX(-20%);
										}

										p {
											color: #FC581C;
											border-bottom: 1px solid #FC581C;
										}
									}
								}

								a {
									display: flex;
									align-items: center;
									padding: .2rem .16rem;

									.icons {
										width: .44rem;
										height: .44rem;
										background: #fff;
										border-radius: 50%;
										display: flex;
										align-items: center;
										justify-content: center;

										img {
											display: block;
											max-width: 80%;
										}
									}

									.grow {
										flex: 1;
										overflow: hidden;
										margin-left: .14rem;

										p {
											width: 1.2rem;
											font-size: .2rem;
											color: #3C3C3C;
											border-bottom: 1px solid #999999;
											font-weight: bold;
											font-family: "微软雅黑";
											padding-bottom: .06rem;
											transition: all .1s;
										}

										span {
											display: block;
											font-size: .12rem;
											font-family: syn;
											line-height: .22rem;
											color: #999999;
											transition: all .1s;
											white-space: nowrap;
											width: 120%;
										}
									}
								}
							}
						}
					}

					&.on {
						background: #FC581C;
					}

					&:hover {
						background: #FC581C;
					}

					&>a {
						height: 100%;
						width: 100%;
						font-size: .18rem;
						color: #fff;
						display: flex;
						align-items: flex-end;
						box-sizing: border-box;
						justify-content: center;
						padding-bottom: .2rem;
					}
				}
			}
		}
	}

	.mobsearch {
		display: none;
	}
}
</style>


// WEBPACK FOOTER //
// src/components/heads2.vue